import React from 'react';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import { useNavigate } from 'react-router-dom';
import TicketColumn from './TicketColumn';
import { useLayout } from '../../../../context/LayoutContext';
import { useTickets } from '../../../../context/TicketsContext';

const DepartmentBoard = ({ departmentId }) => {
  const { theme } = useLayout();
  const navigate = useNavigate();
  const { 
    departments, 
    sections, 
    getTicketsBySection,
    moveTicket,
    reorderTickets,
    setIsCreateModalOpen
  } = useTickets();

  // Encontrar el departamento actual
  const currentDepartment = departments.find(dept => dept.id === departmentId) || {
    id: departmentId,
    name: 'Departamento',
    icon: 'box'
  };

  // Manejar el arrastrar y soltar
  const handleDragEnd = (result) => {
    const { source, destination, draggableId } = result;
    
    // Si no hay destino válido, cancelar
    if (!destination) return;
    
    // Si el origen y destino son iguales, podría ser un reordenamiento en la misma columna
    if (
      source.droppableId === destination.droppableId &&
      source.index !== destination.index
    ) {
      reorderTickets(
        departmentId,
        source.droppableId,
        source.index,
        destination.index
      );
    } 
    // Si es un movimiento entre columnas
    else if (source.droppableId !== destination.droppableId) {
      moveTicket(draggableId, destination.droppableId);
    }
  };

  return (
    <div className={`GM__${theme}-department-board`}>
      {/* Header */}
      <div className={`GM__${theme}-department-board-header`}>
        <div className={`GM__${theme}-board-header-left`}>
          <button 
            className={`GM__${theme}-back-btn`}
            onClick={() => navigate('/help/tickets')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <div className={`GM__${theme}-department-icon`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {currentDepartment.icon === 'box' && <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>}
              {currentDepartment.icon === 'activity' && <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>}
              {currentDepartment.icon === 'users' && <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>}
              {currentDepartment.icon === 'truck' && <path d="M1 3h15v13H1z M16 8h4l3 3v5h-7z"></path>}
            </svg>
          </div>
          <h1 className={`GM__${theme}-department-board-title`}>{currentDepartment.name}</h1>
        </div>
        <div className={`GM__${theme}-board-header-right`}>
          <button 
            className={`GM__${theme}-btn-primary`}
            onClick={() => setIsCreateModalOpen(true)}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Crear Ticket
          </button>
        </div>
      </div>

      {/* Columns */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className={`GM__${theme}-columns-container`}>
          {sections.map(section => (
            <TicketColumn
              key={section.id}
              departmentId={departmentId}
              section={section}
              tickets={getTicketsBySection(departmentId, section.id)}
            />
          ))}
        </div>
      </DragDropContext>
    </div>
  );
};

export default DepartmentBoard;